import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export enum WhatIsAnimaCloseAction {
  close,
  startTest
}

@Component({
  selector: 'app-what-is-anima-modal',
  templateUrl: './what-is-anima-modal.component.html',
  styleUrls: ['./what-is-anima-modal.component.scss']
})
export class WhatIsAnimaModalComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close(WhatIsAnimaCloseAction.close);
  }

  startTest() {
    this.activeModal.close(WhatIsAnimaCloseAction.startTest);
  }
}
